import { useState } from 'react';

import IncidentContentRenderer from '@/components/Incidents/incident-content-renderer';
import SidePanel from '@/components/shared/side-panel';
import useIncidentState from '@/hooks/use-incident-state';

const Incidents = () => {
  const [selectedRoutes, setSelectedRoutes] = useState<{ journeyId: string; lineNumber: string }[]>(
    []
  );
  const [selectedStations, setSelectedStations] = useState<string[]>([]);
  const [tempRoutes, setTempRoutes] = useState<{ journeyId: string; lineNumber: string }[]>([]);
  const [tempStations, setTempStations] = useState<string[]>([]);

  const {
    viewType,
    isShowSidePanel,
    headerText,
    hasHeaderBottomBorder,
    hasBackIcon,
    handleToggleSidePanel,
    handleBackNavigation,
    handleShowFilter,
    handleHideFilter,
  } = useIncidentState();

  const handleOpenFilter = () => {
    setTempRoutes(selectedRoutes);
    setTempStations(selectedStations);
    handleShowFilter();
  };

  const handleApplyFilter = () => {
    setSelectedRoutes(tempRoutes);
    setSelectedStations(tempStations);
    handleHideFilter();
  };

  const handleClearFilter = () => {
    setTempRoutes([]);
    setTempStations([]);
    setSelectedRoutes([]);
    setSelectedStations([]);
  };

  return (
    <SidePanel
      isSidePanelOpen={isShowSidePanel}
      header={headerText}
      viewType={viewType}
      setSidePanelOpen={handleToggleSidePanel}
      hasHeaderBottomBorder={hasHeaderBottomBorder}
      hasBackIcon={hasBackIcon}
      onClickBackIcon={handleBackNavigation}
    >
      <IncidentContentRenderer
        viewType={viewType}
        selectedRoutes={selectedRoutes}
        selectedStations={selectedStations}
        tempRoutes={tempRoutes}
        setTempRoutes={setTempRoutes}
        tempStations={tempStations}
        setTempStations={setTempStations}
        activeFilterCount={selectedRoutes.length + selectedStations.length}
        onShowFilter={handleOpenFilter}
        onApplyFilter={handleApplyFilter}
        onClearFilter={handleClearFilter}
      />
    </SidePanel>
  );
};

export default Incidents;
